import { atom } from "jotai";

/**
 * The station-wide ship date setting. ONE server-stored value shared by every
 * shipping station — deliberately not per-browser and not per-order, so two
 * operators can never print labels for different days.
 */

export type ShipDateMode = 'AUTO' | 'OVERRIDE';

export interface IShippingStationConfig {
    id: number;
    ship_date_mode: ShipDateMode;
    /** `YYYY-MM-DD`, null in AUTO mode. */
    ship_date_override: string | null;
    updated_at: string;
    updated_by: number | null;
}

export interface IResolvedShipDate {
    /** The date labels are stamped with right now, `YYYY-MM-DD`. */
    shipDate: string;
    mode: ShipDateMode;
    isOverride: boolean;
    /** True when a lapsed override was just auto-reverted to AUTO server-side. */
    expiredOverride: boolean;
}

export interface IShipDateConfigResponse {
    config: IShippingStationConfig;
    resolved: IResolvedShipDate;
}

/** Furthest ahead the station may set the date. Mirrors the server-side cap. */
export const MAX_SHIP_DATE_DAYS_AHEAD = 7;

export const shipDateConfigAtom = atom<IShipDateConfigResponse | null>(null);
export const shipDateConfigLoadingAtom = atom<boolean>(false);
